var $imports = require("../../../../../node_modules/art-template/lib/runtime.js");
module.exports = function ($data) {
    'use strict';
    $data = $data || {};
    var $$out = '', $escape = $imports.$escape, HomePdfSign = $data.HomePdfSign;
    $$out += '<ribbon-button class="fv__ui-toolbar-show-text-button" @tooltip tooltip-title=';
    $$out += $escape(HomePdfSign.tooltip);
    $$out += ' name=';
    $$out += $escape(HomePdfSign.name);
    $$out += ' icon-class=';
    $$out += $escape(HomePdfSign.icon);
    $$out += ' text=';
    $$out += $escape(HomePdfSign.title);
    $$out += '></ribbon-button>';
    return $$out;
};